import { fromJS, Map } from 'immutable'

import { LOCATION_CHANGE } from 'react-router-redux'

import uuid from 'utils/uuid'

import {
  ADD_EXTRA_DATA,
  DELETE_EXTRA_DATA_FIELD,
  RESET_STATE,
  UPDATE_DATA,
  UPDATE_EXTRA_DATA_FIELD,
} from './constants'


export const initialState = fromJS({
  vehicleId: null,
  data: {
    company: null,
    broker: null,
    issued_date: '', // controlled React Inputs can't have a null value
    expiration_date: '', // controlled React Inputs can't have a null value
    serial_number: '',
    extra_data: {},
    extra_data_order: [],
    policy_file: null,
    holder_name: '',
    periodicity_type: '',
    coverage: null,
    custom_coverage: '',
    first_charge_date: ''
  }
})


export default function reducer(state = initialState, action) {
  let extra_data, data, extra_data_order

  switch(action.type) {

    /*
    * MODIFYING `policy_data.extra_data` VALUES >>
    * extra_data (Map): store UUID with corresponding "key"/"value"
    *   > this help us to avoid iteration each time we need to update something
    *   > it's faster to search by `Object.key`
    * extra_data_order (List): Useful to store UUID in order, so we can render them in order in UI
    //////////////////////////////////////////////////////////////////////////////
    * first of all we need to get the stored field on `extra_data` with given UUID
    * and based on what the input is storing ("key" or "value") update that --key--
    * of the extra_field
    * keep in mind that `extra_data` stores "key"/"values" like this
    *
    *  extra_data: {
    *    'bfecd676-1345-4ece-b01a-173eaa5bcc1a' : {
    *       key: 'Licencia de Conducir',
    *       value: '48000089237'
    *     }
    *     ...
    *  }
    */
    case UPDATE_EXTRA_DATA_FIELD:
      data = state.get('data')
      extra_data = data.get('extra_data')
      let updated_field = extra_data.get(action.id)

      if (action.isKey)
        updated_field = updated_field.set('key', action.inputValue)
      else
        updated_field = updated_field.set('value', action.inputValue)

      extra_data = extra_data.set(action.id, updated_field)
      data = data.set('extra_data', extra_data)
      return state.set('data', data)
    case DELETE_EXTRA_DATA_FIELD:
      data = state.get('data')
      extra_data = data.get('extra_data')
      extra_data_order = data.get('extra_data_order')

      // we must optimize this to avoid iteration over all items on the List
      extra_data_order = extra_data_order.filter((id) => action.id !== id)
      extra_data = extra_data.delete(action.id)
      data = data.set('extra_data', extra_data)
                 .set('extra_data_order', extra_data_order)
      return state.set('data', data)
    case ADD_EXTRA_DATA:
      const extraUUID = uuid()
      const row = Map({key: action.key, value: action.value})
      data = state.get('data')
      extra_data = data.get('extra_data')
      extra_data_order = data.get('extra_data_order')
      // this must be Immutable so react-redux updates component after UPDATE_EXTRA_DATA_FIELD
      // react-redux createConnect use shallow equal
      extra_data = extra_data.set(extraUUID, row)
      // add UUID to keep adding order.
      extra_data_order = extra_data_order.push(extraUUID)
      data = data.set('extra_data', extra_data)
                 .set('extra_data_order', extra_data_order)
      return state.set('data', data)
    case UPDATE_DATA:
      data = state.get('data')
      data = data.set(action.name, action.value)
      return state.set('data', data)

    case LOCATION_CHANGE:
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/PolicyForm/reducer.js